import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-resource-creator-v2',
  templateUrl: './resource-creator-v2.component.html',
  styleUrl: './resource-creator-v2.component.css',
})
export class ResourceCreatorV2Component {
  constructor(private readonly router: Router) {}

  navigateTo(path: string): void {
    this.router.navigate([path]);
  }
}
